export enum SupportTypes {
  ITA_ID = 1,
  ITE_ID_DIVERSIFIE = 2,
  ITE_ID_RENFORCE_RSA = 3,
  ITE_ID_RENFORCE_HORS_RSA = 4,
  ITE_ID_INNOVANT = 5,
  ITE_ID_AUTRE = 6,
  ITE_ID_PLIE = 7,
  RSJ_ID = 8,
  RSJ_ID_IER = 9,
  ITE_ID_INNOVANT_ACQ = 10,
  ITE_ID_INNOVANT_OTH = 11,
  ITE_ID_INNOVANT_CHI = 12,
  ITE_ID_INNOVANT_COA = 13,
  ITE_ID_INNOVANT_PSP = 14,
  ITE_ID_INNOVANT_REM = 15,
  ITE_ID_DIVERSIFIE_ENT = 16,
  HORS_ACCOMPAGNEMENT = 17,
  RECEPTION = 18,
  ENCOURS_ORIENTATION = 19,
  ACCOMPAGNEMENT_GLOBAL = 20,
  ACCOMPAGNMENT_DROIT_COMMUN = 21,
  SOCIO_PRO_RSA = 22,
  SOCIO_PRO = 23,
  PERLE = 24,
}
